import { SimpleGrid, Table } from "@mantine/core";
import BooleanFormSelect from "components/elements/BooleanFormSelect";
import { CustomInput } from "pages/admin/components/CustomInput";
import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import SalesPersonSelection from "pages/admin/components/SalesPersonSelection";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { DebtorManagementChildFormProps } from "types/interface.types";

const CustomerDetailsCard1: React.FC<DebtorManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const [params] = useSearchParams();
  const { values, setFieldValue } = formApi;
  const id = params.get("id");

  return (
    <div className="card-container ">
      <FormTableLayout>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={Number(id) === 0 ? 4 : 3} spacing="md">
                {Number(id) === 0 && (
                  <CustomInput
                    readonlyMode={readonly}
                    label="Debtor Id"
                    placeholder=""
                    value={String(values.requestedNewId)}
                    onChange={(v) => setFieldValue("requestedNewId", v)}
                  />
                )}
                <CustomInput
                  readonlyMode={readonly}
                  label="Alpha"
                  placeholder=""
                  value={values.alpha}
                  onChange={(v) => setFieldValue("alpha", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Initials"
                  placeholder=""
                  value={values.initials}
                  onChange={(v) => setFieldValue("initials", v)}
                />
                <CustomNumberInput
                  readonlyMode={readonly}
                  asCurrency={false}
                  label="Parent Company"
                  placeholder=""
                  value={values.parentDebtorId}
                  onChange={(v) => setFieldValue("parentDebtorId", v)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Surname"
                placeholder=""
                value={values.surname}
                onChange={(v) => setFieldValue("surname", v)}
              />
            </Table.Td>
            <Table.Td>
              <SalesPersonSelection
                label="Sales Rep"
                placeHolderText="Select Sales Rep"
                value={values.salesRep}
                onChange={(v) => setFieldValue("salesRep", v)}
                readonlyMode={readonly}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Attention 1"
                placeholder=""
                value={values.attn1}
                onChange={(v) => setFieldValue("attn1", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Attention 2"
                placeholder=""
                value={values.attn2}
                onChange={(v) => setFieldValue("attn2", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={4} spacing="md">
                <CustomInput
                  readonlyMode={true}
                  label="Overdue?"
                  value={String(values.overdue ? "Yes" : "No")}
                />
                <BooleanFormSelect
                  readonlyMode={readonly}
                  label="Admin Overdue Override?"
                  value={values.overdueOverride}
                  onChange={(v) => setFieldValue("overdueOverride", v)}
                />
                <BooleanFormSelect
                  readonlyMode={readonly}
                  label="Cash Sale"
                  value={values.cashSale}
                  onChange={(v) => setFieldValue("cashSale", v)}
                />
                <BooleanFormSelect
                  readonlyMode={readonly}
                  label="Active Account?"
                  value={values.active}
                  onChange={(v) => setFieldValue("active", v)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <BooleanFormSelect
                readonlyMode={readonly}
                label="Exclude Invoice From EOM?"
                value={values.excludeInvAndStatementFromEom}
                onChange={(v) =>
                  setFieldValue("excludeInvAndStatementFromEom", v)
                }
              />
            </Table.Td>
            <Table.Td>
              <BooleanFormSelect
                readonlyMode={readonly}
                label="Group Statement and Invoices?"
                value={values.groupStatementAndInvoices}
                onChange={(v) => setFieldValue("groupStatementAndInvoices", v)}
              />
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </FormTableLayout>
    </div>
  );
};
export default React.memo(CustomerDetailsCard1);
